const zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    header: 100,
    headerItem: 101,
};

export default zIndices;
